// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AaIbT-ImageSvg-module_root{display:inline-block;font-size:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "AaIbT-ImageSvg-module_root"
};
export default ___CSS_LOADER_EXPORT___;
